function EditDocIcon({ size = 16 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.1667 10V12C13.1667 13.612 12.2787 14.5 10.6667 14.5H4C2.388 14.5 1.5 13.612 1.5 12V5.33333C1.5 3.72133 2.388 2.83333 4 2.83333H6C6.276 2.83333 6.5 3.05733 6.5 3.33333C6.5 3.60933 6.276 3.83333 6 3.83333H4C2.94867 3.83333 2.5 4.282 2.5 5.33333V12C2.5 13.0513 2.94867 13.5 4 13.5H10.6667C11.718 13.5 12.1667 13.0513 12.1667 12V10C12.1667 9.724 12.3907 9.5 12.6667 9.5C12.9427 9.5 13.1667 9.724 13.1667 10ZM14.5 4.03733C14.4993 4.42867 14.3467 4.796 14.0693 5.072L8.09399 11.0207C7.99999 11.114 7.87333 11.1667 7.74133 11.1667H5.33333C5.05733 11.1667 4.83333 10.9427 4.83333 10.6667V8.25934C4.83333 8.12734 4.88533 7.99999 4.97933 7.90666L10.928 1.93066C11.2034 1.65333 11.5713 1.50067 11.9626 1.5C11.9633 1.5 11.964 1.5 11.9647 1.5C12.3553 1.5 12.7227 1.652 12.9993 1.92867L14.072 3.00134C14.348 3.27801 14.5007 3.646 14.5 4.03733ZM11.7447 5.97534L10.0247 4.25533L5.83333 8.466V10.1673H7.53467L11.7447 5.97534ZM13.5 4.03599C13.5 3.91199 13.452 3.79534 13.3647 3.70801L12.292 2.63534C12.2047 2.548 12.088 2.5 11.9647 2.5H11.964C11.84 2.5 11.724 2.54867 11.6367 2.63601L10.7307 3.546L12.454 5.26933L13.364 4.36334C13.4513 4.27668 13.4993 4.15999 13.5 4.03599Z'
        fill='#25314C'
      />
    </svg>
  );
}

export default EditDocIcon;
